import React from "react";

const Main = () => {
  return (
<div className="bg-[linear-gradient(to_right,_#bfdbfe_25%,_white_70%)] px-6 py-12 flex flex-col md:flex-row justify-around items-center">

      
      <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
        <img
          className="w-full max-w-[800px] h-auto rounded-lg shadow-lg"
          src="assets/desarrollosoftware2.png"
          alt="Desarrollo de Software"
        />
      </div>

     
      <div className="w-full md:w-1/2 px-4 text-center md:text-left">
        <p className="text-lg text-gray-700 leading-relaxed">
          En <span className="font-bold text-[#007fba]">DISOMEX</span>, nos
          especializamos en la creación de soluciones digitales innovadoras que
          transforman ideas en realidad. Con una profunda pasión por el diseño
          y la programación, nuestro equipo de expertos trabaja sin descanso
          para ofrecer productos de software a medida que no solo cumplen, sino
          que superan las expectativas de nuestros clientes. Desde el diseño
          intuitivo de interfaces hasta el desarrollo robusto de aplicaciones
          web y software personalizado, cada proyecto es una oportunidad para
          demostrar nuestro compromiso con la excelencia técnica y creativa.
        </p>
      </div>
    </div>
  );
};

export default Main;
